import { FormFieldGroup, FormInput, FormLabel } from '$components'
import { Input } from './index'

export function UpdateParentInformationContent() {
  return (
    <div className="flex flex-col gap-stack-section flex-grow">
      <div className="grid md:grid-cols-2 gap-stack-roomy">
        <FormFieldGroup>
          <FormLabel htmlFor={Input.FirstName}>
            First Name
          </FormLabel>
          <FormInput
            name={Input.FirstName}
            placeholder="Enter first name..."
          />
        </FormFieldGroup>

        <FormFieldGroup>
          <FormLabel htmlFor={Input.LastName}>
            Last Name
          </FormLabel>
          <FormInput
            name={Input.LastName}
            placeholder="Enter last name..."
          />
        </FormFieldGroup>
      </div>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.Email}>
          Email
        </FormLabel>
        <FormInput
          name={Input.Email}
          type="email"
          placeholder="Enter parent email..."
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.Phone}>
          Phone
        </FormLabel>
        <FormInput
          name={Input.Phone}
          placeholder="Enter parent phone..."
        />
      </FormFieldGroup>
    </div>
  )
}
